<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="关键字" name="keyword"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button power="b_product_popular_key_words_add" color="sys" @click="createPopularKeyWords()">新增</c-button>
			</m-operate>
			
			<c-table ref="table" code="product_popular_key_words_list">
				<c-table-column
					label="关键字"
					name="keyword"
					width="120"
				>
				</c-table-column>
				
				<c-table-column
					label="字颜色"
					name="color"
					width="80"
				>
				</c-table-column>
				
				<c-table-column
					label="链接参数"
					name="params"
					width="300"
				>
				</c-table-column>
				
				<c-table-column
					label="链接参数描述"
					name="params_desc"
					width="120"
				>
				</c-table-column>
				
				<!-- <c-table-column
					label="展示类型"
					name="type"
					width="80"
				>
					<template v-slot="{data}">
						{{data.type == 2 ? '搜索框内' : '搜索框外'}}
					</template>
				</c-table-column> -->

				<c-table-column
					label="状态"
					name="state"
					width="60"
				>
					<template v-slot="{data}">
					  <span style="color:darkgreen" v-if="data.state==2">启用</span>
					  <span style="color:red" v-if="data.state==1">禁用</span>
					</template>
				</c-table-column>

				<c-table-column
					label="创建日期"
					name="create_date"
					width="140"
				>
				</c-table-column>
				
				<c-table-column
					type="sort"
					label="排序"
					name="sort_id"
					power="b_product_popular_key_words_sort"
					@sort="sortHandle"
				>
				</c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="160"
				>
					<template v-slot="{data}">
						<c-table-button power="b_product_popular_key_words_edit" @click="edit(data)">编辑</c-table-button>
						<c-table-button power="b_product_popular_key_words_del" @click="del(data)">删除</c-table-button>
						<c-table-button power="b_product_popular_key_words_state" v-if="data.state == 1" @click="updateState(2, data)">{{'启用'}}</c-table-button>
						<c-table-button power="b_product_popular_key_words_state" v-if="data.state == 2" @click="updateState(1, data)">{{'禁用'}}</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="editDialog" :title="editState ? '编辑热门关键字' : '新增热门关键字'" width="600" @resolve="submitForm">
			<c-form ref="editForm">
				<c-form-item type="input" label="关键字" name="keyword" required></c-form-item>
				<c-form-item type="color" label="颜色" name="color"></c-form-item>
				<c-form-item type="link" label="链接参数" name="params" required></c-form-item>
				<c-form-item type="textarea" label="链接参数描述" name="params_desc" ></c-form-item>
				<!-- <c-form-item type="radio" label="展示类型" name="type" :options="typeArray" required></c-form-item> -->
				<c-form-item type="radio" label="状态" name="state" :options="stateArray" value="2" required></c-form-item>
				<c-form-item type="hidden" name="id"></c-form-item>
			</c-form>
		</c-dialog>
	</page>
</template>

<script>
	export default {
		name: 'm_product_popular_key_words',
		
		data() {
			return {
				typeArray: [{
					name: '搜索框外',
					value: 1
				},{
					name: '搜索框内',
					value: 2
				}],

				stateArray: [{
					name: '禁用',
					value: 1
				},{
					name: '启用',
					value: 2
				}],

				editState: false
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/product_popular_key_words/list',
					data
				});
			},

			sortHandle(row, type, next) {
				//row.prev() 上一行数据
				//row.next() 下一行数据
				let submitData ={};
				if(type=='top' || type=='bottom'){
					submitData.type = type;
					submitData.id = row.data.id;
				}
				if(type=='up'){
					submitData.id1 = row.data.id;
					submitData.id2 = row.prev().data.id;
				}
				if(type=='down'){
					submitData.id1 = row.data.id;
					submitData.id2 = row.next().data.id;
				}
				this.request({
					url: '/product_popular_key_words/sort',
					data: submitData,
					loading: true,
					success: data => {
						next();
					}
				});
			},

			createPopularKeyWords() {
				this.editState = false;
				this.$refs.editForm.clear();
				this.$refs.editForm.set({state:2,type:2});
				this.$refs.editDialog.open();
			},
			
			edit(val) {
				this.editState = true;
				this.$refs.editForm.set(val);
				this.$refs.editDialog.open();
			},

			del(val) {
				this.$confirm({
					text: '确定要删除【'+val.keyword+'】吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/product_popular_key_words/remove',
							data: {id:val.id},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			updateState(type,val) {
				this.$confirm({
					text: '确定要'+(type==2?'启用':'禁用')+'【'+val.keyword+'】吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/product_popular_key_words/update_state',
							data: {id:val.id,state:type},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			submitForm(stop) {
				stop();
				let submitUrl = '/product_popular_key_words/add';
				if(this.editState){
					submitUrl = '/product_popular_key_words/edit';
				}
				this.$refs.editForm.submit({
					url: submitUrl,
					rule: {
						keyword: [{
							type: 'empty',
							word: '请填写关键字'
						}],
						params: [{
							type: 'empty',
							word: '请填写链接参数'
						}],
						// type: [{
						// 	type: 'empty',
						// 	word: '请选择展示类型'
						// }],
						state: [{
							type: 'empty',
							word: '请选择状态'
						}],
					},
					dataFormatter: data => {
						data.type = 2;
						return data;
					},
					success:(data,res) => {
						this.$message({
							text: '操作成功',
							icon: 'success'
						});
						this.$refs.table.update();
						this.$refs.editDialog.close();
					},
				});
			}
		}
	}
</script>